import React from 'react';
import PropTypes from 'prop-types';
import './ProjectInfo.css';

function ProjectInfoBox(props) {
  const { title, tag } = props;
  return (
    <div className="project-info-box">
      <h6>{title}</h6>
      <p>{tag}</p>
    </div>
  );
}

ProjectInfoBox.propTypes = {
  title: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
};

export default ProjectInfoBox;
